<form [formGroup]="sitProForm" class="sitProForm" novalidate autocomplete="off">

    <div class="form-group">
    
        <!-- Q1 : Vous êtes actuellement -->
        <ccd-boutons-radio 
            *ngIf="affichageQuestions.isQuestionSituation"
            name="questionSitPro"
            id="{{id}}_SITPRO"
            [libelle]="libelleQuestions.libelleQuestionSituation"
            [configurationBoutons]="libelleQuestions.reponsesQuestionSituation"
            [valeur]="codeSituation"
            (dataChange)="codeSituation = $event">
        </ccd-boutons-radio>
        
        <!--Q2 : En activité professionnelle -->
        <ccd-boutons-radio 
            *ngIf="affichageQuestions.isQuestionProfessionnelle"
            name="questionActPro"
            id="{{id}}_ACTPRO"
            [libelle]="libelleQuestions.libelleQuestionActiviteProfessionnelle"
            [configurationBoutons]="libelleQuestions.reponsesQuestionActiviteProfessionnelle"
            [valeur]="enActivite"
            (dataChange)="enActivite = $event">
        </ccd-boutons-radio>

        <!--Q2.2 : Au chomage -->
        <ccd-boutons-radio 
            *ngIf="affichageQuestions.isQuestionChomage"
            name="questionChomage"
            id="{{id}}_CHOMAGE"
            [libelle]="libelleQuestions.libelleQuestionChomage"
            [configurationBoutons]="libelleQuestions.reponsesQuestionChomage"
            [valeur]="auChomage"
            (dataChange)="auChomage = $event">
        </ccd-boutons-radio>

        <!--Q3 : Indemnise -->
        <ccd-boutons-radio 
            *ngIf="affichageQuestions.isQuestionIndemnise"
            name="questionIndemnite"
            id="{{id}}_INDMNITE"
            [libelle]="libelleQuestions.libelleQuestionIndemnise"
            [configurationBoutons]="libelleQuestions.reponsesQuestionIndemnise"
            [valeur]="indemnite"
            (dataChange)="indemnite = $event">
        </ccd-boutons-radio>

    </div>

</form>
